<section class="section-title">

  <div class="section-title-image" *ngIf="owner">
    <img class="owner-image" src="assets/img/owner.png" />
  </div>

  <div class="section-title-text">
    <h1>{{ owner?.displayName }}</h1>

    <p>
      <ng-container i18n="@@ownerdetail_email">Email:</ng-container> {{owner?.email}} <br />
      <ng-container i18n="@@ownerdetail_uid">ID:</ng-container> {{owner?.uid}} <br />
    </p>

  </div>

</section>


<!-- Admin view -->
<section *ngIf="!isService()">

  <div class="buttons-container">
    <a (click)="openRequestForm()" class="button" style="margin-right : 15px">
      <ng-container i18n="@@ownerdetail_request_form">Form richiesta transito</ng-container> <span><fa-icon
          icon="table"></fa-icon></span>
    </a>

    <a (click)="usersImport()" class="button" style="margin-right : 15px">
      <ng-container i18n="@@ownerdetail_user_import">Importazione utenti</ng-container> <span><fa-icon
          icon="upload"></fa-icon></span>
    </a>

    <a (click)="connectDevice()" class="button">
      <ng-container i18n="@@ownerdetail_connect_device">Collega dispositivo</ng-container> <span><fa-icon
          icon="link"></fa-icon></span>
    </a>
  </div>

  <div class="map-container">
    <app-owner-devices-map *ngIf="owner" [reload]="reload" [owner]="owner"
      (selected)="onDeviceSelected($event)"></app-owner-devices-map>
  </div>

  <div id="ownersLayout" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start">

    <div fxFlex="65" [fxFlex.lt-md]="0">

      <app-owner-devices-list *ngIf="owner" [reload]="reload" [owner]="owner"
        (selected)="onDeviceSelected($event)"></app-owner-devices-list>

    </div>

    <div fxFlex="35" [fxFlex.lt-md]="0">

      <div id="ownerDetailRightCard" class="control-card-white">

        <div class="control-card-header">
          <ng-container i18n="@@ownerdetail_details">Dettagli</ng-container>
        </div>

        <div class="control-card-content" *ngIf="owner">

          <!-- class="simple-table" -->
          <table>

            <tr>
              <td class="text-dark" i18n="@@ownerdetail_email">Email</td>
              <td>
                <label class="td-label">{{ owner?.email }}</label>
              </td>
            </tr>

            <tr>
              <td class="text-dark" i18n="@@ownerdetail_name">Nominativo</td>
              <td>
                <input [(ngModel)]="newDisplayName" />
              </td>
            </tr>

            <br>

            <a id="saveButton" (click)="saveName()" class="button" style="margin-left: 20px">
              <ng-container i18n="@@ownerdetail_save">Salva</ng-container> <span>
                <fa-icon icon="check"></fa-icon>
              </span>
            </a>


          </table>
        </div>

      </div>

    </div>

  </div>

</section>




<!-- Service view -->
<section *ngIf="isService()">
  <div>

    <mat-tab-group [animationDuration]="'0ms'" (selectedTabChange)="onTabChange($event)"
      [(selectedIndex)]="selectedTabIndex">

      <mat-tab label={{devicesString}}>

        <div class="map-container">
          <app-owner-devices-map *ngIf="owner" [reload]="reload" [owner]="owner"
            (selected)="onDeviceSelected($event)"></app-owner-devices-map>
        </div>

        <div id="ownersLayout" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="flex-start">

          <div fxFlex="65" [fxFlex.lt-md]="0">

            <app-owner-devices-list *ngIf="owner" [reload]="reload" [owner]="owner"
              (selected)="onDeviceSelected($event)"></app-owner-devices-list>

          </div>

          <div fxFlex="35" [fxFlex.lt-md]="0">

            <div id="ownerDetailRightCard" class="control-card-white">

              <div class="control-card-header">
                <ng-container i18n="@@ownerdetail_details">Dettagli</ng-container>
              </div>

              <div class="control-card-content" *ngIf="owner">

                {{ owner?.email }}

              </div>

            </div>

          </div>

        </div>

      </mat-tab>


      <mat-tab label={{automationsString}}>

        <app-automations hideHeader="true"> </app-automations>

      </mat-tab>

      <mat-tab label={{usersString}}>

        <app-owner-users hideHeader="true"> </app-owner-users>

      </mat-tab>

      <mat-tab label={{groupsString}}>

        <app-groups hideHeader="true"> </app-groups>

      </mat-tab>

    </mat-tab-group>

  </div>


</section>

<app-loading-screen #ownerloader></app-loading-screen>